module.exports = __webpack_public_path__ + "static/media/maria.a772977e.jpg";